import { useEffect } from 'react';
import { hasAnalyticsConsent } from '../components/CookieNotification/CookieNotification';

const GA_ID = 'G-7Q2BH0054D';

const loadGA = () => {
  if (window.__gaLoaded) return;
  window.__gaLoaded = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_ID, { anonymize_ip: true });
};

const useAnalytics = () => {
  useEffect(() => {
    // Load immediately if consent was already given
    if (hasAnalyticsConsent()) {
      loadGA();
    }

    // Listen for future consent decisions
    const handleConsentUpdate = (e) => {
      if (e.detail?.analytics === true) {
        loadGA();
      }
    };

    window.addEventListener('gdpr-consent-updated', handleConsentUpdate);
    return () => {
      window.removeEventListener('gdpr-consent-updated', handleConsentUpdate);
    };
  }, []);
};

export default useAnalytics;
